import { useNavigate } from "react-router-dom";
import { PendingApproval } from "../model/pendingApprovalModel";
import { setOpenMenu } from "../viewmodel/pendingAction.action";
import { Job } from "../model/JobModel";

interface JobPendingApprovalCardProps {
  jobPending: PendingApproval;
  // onEdit: (job: Job) => void;
  openMenuJobId: string | null;
  dispatch: React.Dispatch<any>;
  onAction: (jobId: string, action: "approve" | "reject") => void;
}

export default function JobPendingApprovalCard({
  jobPending,
  openMenuJobId,
  dispatch,
  onAction,
}: JobPendingApprovalCardProps & { viewMode?: string }) {
  const isOpen = openMenuJobId === jobPending.job_id;
  const navigate = useNavigate();

  const handleViewJobDetails = (jobPending: PendingApproval) => {
    navigate(`/company/JobDetails/${jobPending.job_id}`, {
      state: {
        ...jobPending,
        id: jobPending.job_id,
        title: jobPending.job_title,
        source: "pending",
      },
    });
    // navigate(`/company/JobDetails/${job.id}`, { state: job });
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border hover:shadow-md transition-shadow duration-200  h-full flex flex-col">
      <div className="p-4 flex flex-col flex-grow">
        <div className="grid grid-cols-[40px_1fr_auto] items-center gap-3 mb-3">
          <div className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center">
            <span className="text-indigo-600 font-medium text-sm">
              {jobPending.job_title?.[0]?.toUpperCase()}
            </span>
          </div>
          <div>
            <span className="text-sm font-medium text-gray-900 truncate line-clamp-2">
              {jobPending.job_title}
            </span>
          </div>

          <div className="flex items-center gap-2">
            <div className="relative">
              <button
                onClick={() =>
                  dispatch(
                    setOpenMenu(
                      openMenuJobId === jobPending.job_id
                        ? null
                        : jobPending.job_id,
                    ),
                  )
                }
                className="p-2 hover:bg-gray-100 rounded-full"
              >
                ⋮
              </button>

              {isOpen && (
                <div className="absolute right-0 mt-2 w-32 bg-white border rounded-lg shadow-lg py-1 z-20">
                  <button
                    onClick={() => {
                      onAction(jobPending.job_id, "approve");
                      //   dispatch(setOpenMenu(null));
                      //   onEdit(job);
                    }}
                    className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                  >
                    Approve
                  </button>
                  <button
                    onClick={() => {
                      onAction(jobPending.job_id, "reject");
                    }}
                    className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                  >
                    Reject
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <div>
          <div className="flex items-center text-sm justify-between mb-2">
            <div>
              <span className="font-semibold text-gray-500">Total Levels:</span>{" "}
              <span className="text-blue-600 font-medium">
                {jobPending?.total_levels}
              </span>
            </div>

            <div>
              <span className="font-semibold text-gray-500">
                Current Level:
              </span>{" "}
              <span className="text-blue-600 font-medium">
                {jobPending?.current_level}
              </span>
            </div>
          </div>

          <div className="flex gap-2  mt-auto justify-end">
            <button
              onClick={() => handleViewJobDetails(jobPending)}
              className="w-[10vh] text-xs bg-indigo-600 text-white px-2 py-1 rounded hover:bg-indigo-700"
            >
              View
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
